module.exports = __webpack_public_path__ + "static/img/tip_no_support.ae30212f.svg";